<p-skeleton width="100%" height="100%" *ngIf="!loaded"></p-skeleton>
<ng-container #vc></ng-container>
